import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  z-index: ", ";\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/core';
import { layers } from '@atlaskit/theme/constants';
var primitiveCss = css(_templateObject(), layers.tooltip());
var TooltipPrimitive = /*#__PURE__*/forwardRef(function TooltipPrimitive(_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      placement = _ref.placement,
      testId = _ref.testId;
  return jsx("div", {
    role: "tooltip",
    ref: ref,
    style: style,
    className: className,
    css: primitiveCss,
    "data-placement": placement,
    "data-testid": testId
  }, children);
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
export default TooltipPrimitive;